import { render } from "./MainProductsAccordingToModuleEntered.vue?vue&type=template&id=0c884c2a&scoped=true"
import script from "./MainProductsAccordingToModuleEntered.vue?vue&type=script&lang=js"
export * from "./MainProductsAccordingToModuleEntered.vue?vue&type=script&lang=js"

import "./MainProductsAccordingToModuleEntered.vue?vue&type=style&index=0&id=0c884c2a&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c884c2a"]])

export default __exports__